import { render, staticRenderFns } from "./gmsqDialog.vue?vue&type=template&id=64d74f21&scoped=true&"
import script from "./gmsqDialog.vue?vue&type=script&lang=js&"
export * from "./gmsqDialog.vue?vue&type=script&lang=js&"
import style0 from "./gmsqDialog.vue?vue&type=style&index=0&id=64d74f21&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d74f21",
  null
  
)

export default component.exports